import {
  Box,
  Checkbox,
  TableCell,
  TableRow,
  TableSortLabel,
  Typography,
  useTheme,
} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { visuallyHidden } from '@mui/utils';

const TableRowSort = ({
  columns,
  onSort = () => {},
  order,
  orderBy,
  backgroundColor,
  colorText = '#fff',
  sx,
  rows,
  numSelected = 0,
  onSelectAll = () => {},
  isChecked,
}) => {
  const theme = useTheme();

  return (
    <TableRow>
      {columns?.map((column) => {
        const indeterminate =
          column?.checkbox &&
          column?.selectable &&
          numSelected > 0 &&
          numSelected < rows?.length;
        return (
          <TableCell
            key={uuidv4()}
            variant='head'
            align={'left'}
            sx={{
              backgroundColor:
                backgroundColor || theme.palette.secondary.medium,
              width: column.width,
              ...sx,
            }}
            sortDirection={
              column?.sortable && orderBy === column?.key ? order : false
            }
          >
            {column?.sortable ? (
              <TableSortLabel
                active={orderBy === column?.key}
                direction={orderBy === column?.key ? order : 'asc'}
                onClick={() => {
                  onSort(column?.key);
                }}
              >
                <Typography
                  variant='body1'
                  color={colorText}
                  textTransform={'uppercase'}
                  fontWeight='bold'
                >
                  {column.label}
                </Typography>
                {orderBy === column?.key ? (
                  <Box component='span' sx={visuallyHidden}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : column?.checkbox && column?.selectable ? (
              <Checkbox
                checked={isChecked || false}
                color='primary'
                indeterminate={indeterminate}
                onClick={
                  column?.checkbox && column?.selectable ? onSelectAll : null
                }
              />
            ) : (
              <Typography
                variant='body1'
                color={colorText}
                fontWeight='bold'
                textTransform={'uppercase'}
              >
                {column?.label}
              </Typography>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default TableRowSort;
